import { BrowserModule } from "@angular/platform-browser";
import { ErrorHandler, NgModule } from "@angular/core";
import { HttpModule, Http } from "@angular/http";
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { IonicApp, IonicErrorHandler, IonicModule } from "ionic-angular";
import { SplashScreen } from "@ionic-native/splash-screen";
import { StatusBar } from "@ionic-native/status-bar";
import { AppVersion } from "@ionic-native/app-version";
import { IonicStorageModule } from "@ionic/storage";
import { DatePicker } from "@ionic-native/date-picker";
import { Keyboard } from "@ionic-native/keyboard";
import { Camera } from "@ionic-native/camera";
import { InAppBrowser } from "@ionic-native/in-app-browser";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { MyApp } from "./app.component";
import { AuthProvider } from "../providers/auth/auth";
import { SignaturePadModule } from "angular2-signaturepad";
import { HomePageModule } from "../pages/home/home.module";
import { LoginPageModule } from "../pages/login/login.module";
import { SettingsPageModule } from "../pages/settings/settings.module";
import { PatientsPageModule } from "../pages/patients/patients.module";
import { PatientAddPageModule } from "../pages/patient-add/patient-add.module";
import { SurveyPageModule } from "../pages/survey/survey.module";
import { PatientDetailsPageModule } from "../pages/patient-details/patient-details.module";
import { PatientMedicationPageModule } from "../pages/patient-medication/patient-medication.module";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { ImageProvider } from '../providers/image/image';
import { AppConfig } from "../providers/config";
import { FirestoreProvider } from '../providers/firestore/firestore';
import { AngularFireModule, FirebaseApp } from 'angularfire2';
import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFireFunctions } from 'angularfire2/functions';
import { AngularFirestoreModule } from 'angularfire2/firestore';
import { AngularFireStorageModule } from 'angularfire2/storage';
import { StudiesPageModule } from '../pages/studies/studies.module';
import { ScannerServiceProvider } from '../providers/scanner-service/scanner-service';
import { PatientUploadPageModule } from "../pages/patient-upload/patient-upload.module";
import { DatabaseProvider } from '../providers/database/database';
import { MedicationsPageModule } from "../pages/medications/medications.module";
import { PrescriptionsPageModule } from "../pages/prescriptions/prescriptions.module";
import { DirectivesModule } from "../directives/directives.module";
import { AdminClinicsPageModule } from "../pages/admin-clinics/admin-clinics.module";
import { AdminMedicationsPageModule } from "../pages/admin-medications/admin-medications.module";
import { AdminDoctorsPageModule } from "../pages/admin-doctors/admin-doctors.module";
import { AdminUsersPageModule } from "../pages/admin-users/admin-users.module";
import { AdminPrescriptionsPageModule } from "../pages/admin-prescriptions/admin-prescriptions.module";
import { AdminStudiesPageModule } from "../pages/admin-studies/admin-studies.module";
import { AdminClinicSwitchPageModule } from "../pages/admin-clinic-switch/admin-clinic-switch.module";
import { AdminClinicDetailsPageModule } from "../pages/admin-clinic-details/admin-clinic-details.module";
import { AdminUtilityPageModule } from "../pages/admin-utility/admin-utility.module";

import { AgGridModule } from 'ag-grid-angular';
import { ClinicDoctorsPageModule } from "../pages/clinic-doctors/clinic-doctors.module";
import { ClinicMedicationsPageModule } from "../pages/clinic-medications/clinic-medications.module";
import { AdminUsersAddPageModule } from "../pages/admin-users-add/admin-users-add.module";
import { AdminClinicsAddPageModule } from "../pages/admin-clinics-add/admin-clinics-add.module";
import { ClinicMedicationsAddPageModule } from "../pages/clinic-medications-add/clinic-medications-add.module";
import { AdminPrescriptionUpdatePageModule } from "../pages/admin-prescription-update/admin-prescription-update.module";
import { UtilityProvider } from '../providers/utility/utility';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}

@NgModule({
  declarations: [
    MyApp
    ],
  imports: [
    BrowserModule,
    HttpModule,
    HttpClientModule,
    SignaturePadModule,
    BrowserAnimationsModule,
    AgGridModule.withComponents([]),
    IonicModule.forRoot(MyApp, {
      iconMode: "md",
      mode: "md",
      tabsPlacement: "bottom",
      scrollAssist: false, 
      autoFocusAssist: false
    }),
    IonicStorageModule.forRoot(),
    AngularFireModule.initializeApp(AppConfig.constants.FIREBASE_CONFIG),
    AngularFirestoreModule,
    AngularFireStorageModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    }),
    HomePageModule,
    LoginPageModule,
    SettingsPageModule,
    PatientsPageModule,
    PatientDetailsPageModule,
    PatientAddPageModule,
    PatientMedicationPageModule,
    SurveyPageModule,
    StudiesPageModule,
    PatientUploadPageModule,
    MedicationsPageModule,
    PrescriptionsPageModule,
    DirectivesModule,

    AdminClinicsPageModule,
    AdminClinicsAddPageModule,
    AdminClinicDetailsPageModule,
    AdminMedicationsPageModule,
    AdminDoctorsPageModule,
    AdminPrescriptionsPageModule,
    AdminPrescriptionUpdatePageModule,
    AdminStudiesPageModule,
    AdminUsersPageModule,
    AdminUsersAddPageModule,
    AdminClinicSwitchPageModule,
    AdminUtilityPageModule,

    ClinicDoctorsPageModule,
    ClinicMedicationsPageModule,
    ClinicMedicationsAddPageModule
  ],
  bootstrap: [IonicApp],
  entryComponents: [MyApp],
  providers: [
    Camera,
    StatusBar,
    SplashScreen,
    AppVersion,
    DatePicker,
    Keyboard,
    InAppBrowser,
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    AuthProvider,
    ImageProvider,
    FirestoreProvider,
    AngularFireAuth,
    AngularFireFunctions,
    ScannerServiceProvider,
    DatabaseProvider,
    UtilityProvider
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts